import { Component } from 'react';
import Collapse from 'react-bootstrap/Collapse';

class SynopsisComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      readMore: false,
    };
  }

  toggleReadMore = () => {
    this.setState({
      readMore: !this.state.readMore,
    });
  };

  render() {
    const { synopsis } = this.props;
    const { readMore } = this.state;
    return (
      <>
        <div className="synopsis-blk">
          <div className="synopsis-wrap">
            <div className="synopsis-text">
              {!readMore ? (
                <p>
                  <span className="font-bold">Synopsis</span>
                  {synopsis}
                </p>
              ) : null}
            </div>
          </div>

          <div className="more-btn-wrap">
            {!readMore && synopsis.length > 154 && (
              <a aria-controls="synopsis-text" aria-expanded={readMore} onClick={this.toggleReadMore} className="read-more-btn" href="javascript:;">
                <span>MORE</span>
              </a>
            )}
          </div>
        </div>

        <Collapse in={readMore}>
          <div id="synopsis-text">
            <p>
              <span className="font-bold">Synopsis</span>
              {synopsis}
              <a aria-controls="synopsis-text" aria-expanded={readMore} onClick={this.toggleReadMore} className="read-more-btn" href="javascript:;">
                &nbsp;<span>LESS</span>
              </a>
            </p>
          </div>
        </Collapse>
      </>
    );
  }
}

export default SynopsisComponent;
